var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validation--wrapper",class:{'hide-validation': _vm.hideValidation}},[_vm._t("default"),(!_vm.hideValidation)?_c('div',{staticClass:"validation--message"},[(_vm.validation)?_c('validation-message',{attrs:{"validation":_vm.validation}}):_vm._e()],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }